<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<mat-dialog-content>
  <h2 mat-dialog-title style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Approving
    tenant: {{tenant.companyName}}</h2>
  <div *ngFor="let user of users">
    <span>
      Creator: {{user.lastName}} {{user.firstName}} {{user.emailAddress}}
    </span>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button [disabled]="loading" (click)="initializeTenant()" style="border-radius: 6px;">Approve
  </button>
  <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
</mat-dialog-actions>
